module.exports = __webpack_public_path__ + "img/22.306fa59b.jpg";